import { SERVICES_URL, SERVICES_APP_URL, MAP_URL, CASH_URL } from './appsUrls';

export const HEADER_MENU_ITEMS = [
  {
    label: 'Wallet',
    data: [
      {
        title: 'Wallet',
        path: `${SERVICES_URL}/wallets`,
      },
      {
        title: 'Operaciones en marcha',
        path: `${SERVICES_URL}/wallets/movements`,
      },
      {
        title: 'Perfil',
        collapseData: [
          // {
          //   title: 'personalInformation',
          //   path: `${SERVICES_URL}/personal-information`,
          // },
          // {
          //   title: 'domcilie',
          //   path: `${SERVICES_URL}/domicilial-information`,
          // },
          {
            title: 'Central de verificación',
            path: `${SERVICES_URL}/settings/verification-center`,
          },
          {
            title: 'Seguridad',
            path: `${SERVICES_URL}/settings/security`,
          },
        ],
      },
      {
        title: 'Bancos',
        path: `${SERVICES_APP_URL}/banks`,
      },
      {
        title: 'Tarjeta',
        path: `${SERVICES_URL}/wallets/cards`,
      },
      {
        title: 'Mis billeteras',
        path: `${SERVICES_URL}/wallets/list`,
      },
      {
        title: 'Cash in',
        path: `${SERVICES_APP_URL}/broker?operation=cash-in&medium=Banco`,
      },
      {
        title: 'Cash out',
        path: `${SERVICES_APP_URL}/broker?operation=cash-out&medium=Banco`,
      },
      {
        title: 'Swap',
        path: `${SERVICES_URL}/wallets/swap`,
      },
      {
        title: 'K2P',
        path: `${SERVICES_URL}/k2p`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
  {
    label: 'Comercio',
    data: [
      {
        title: 'Pos de pago',
        path: CASH_URL,
      },
      {
        title: 'Historial de pagos',
        path: `${CASH_URL}/payments`,
      },
      {
        title: 'Mi tienda',
        collapseData: [
          {
            title: 'Información de la empresa',
            path: `${SERVICES_URL}/settings/comercios/my-store`,
          },
          {
            title: 'Monedas y tokens',
            path: `${SERVICES_URL}/settings/comercios/my-store/tokens-currencies`,
          },
          {
            title: 'Tiendas',
            path: `${SERVICES_URL}/settings/comercios/my-store/locales`,
          },
        ],
      },
      {
        title: 'Datos comerciales',
        path: `${CASH_URL}/profile`,
      },
      {
        title: 'Ajustes',
        path: `${SERVICES_URL}/settings/comercios`,
      },
      {
        title: 'Reporte',
        path: `${CASH_URL}/reports`,
      },
      {
        title: 'Usuarios',
        path: `${SERVICES_URL}/settings/comercios/users`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
  {
    label: 'Servicios',
    data: [
      {
        title: 'Servicios',
        path: SERVICES_APP_URL,
      },
      {
        title: 'Kriptosearch',
        path: `${SERVICES_APP_URL}/kriptosearch`,
      },
      {
        title: 'Kriptostore',
        path: `${SERVICES_APP_URL}/kriptostore`,
      },
      {
        title: 'Payments',
        path: `${SERVICES_APP_URL}/kriptopayment`,
      },
      {
        title: 'Maps',
        path: MAP_URL,
      },
      {
        title: 'Marketplace',
        path: `${SERVICES_APP_URL}/kriptosearch?country=ARG&provider=kriptonmarket`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
];
